'use client'

import {CircleAlert, CircleCheck, Info, TriangleAlert} from 'lucide-react'
import React from 'react'
import {Toaster} from 'sonner'
import {useResponsive} from '../../../hooks/useResponsive'
import {useTranslation} from '../../../hooks/useTranslation'

// Sonner's injected styles win the cascade, so Fitro tokens need the important modifier.
const toastClassNames = {
    toast: [
        '!rounded-2xl !border-gray-200 !bg-white !px-4 !py-3 !font-sans !text-gray-900',
        '!shadow-lg !shadow-gray-900/10',
        'dark:!border-gray-700 dark:!bg-gray-800 dark:!text-white'
    ].join(' '),
    title: '!text-sm !font-medium !leading-5',
    actionButton: '!h-8 !rounded-lg !bg-primary-600 !px-3 !text-sm !font-semibold !text-white'
}

const icons = {
    success: <CircleCheck aria-hidden className="h-4 w-4 text-success-600"/>,
    error: <CircleAlert aria-hidden className="h-4 w-4 text-error-600"/>,
    warning: <TriangleAlert aria-hidden className="h-4 w-4 text-warning-600"/>,
    info: <Info aria-hidden className="h-4 w-4 text-primary-600"/>
}

export const FitroToaster: React.FC = () => {
    const {isDesktop} = useResponsive()
    const {t} = useTranslation('notifications')

    return (
        <Toaster
            position={isDesktop ? 'top-right' : 'top-center'}
            offset={24}
            mobileOffset={12}
            gap={10}
            icons={icons}
            containerAriaLabel={t('toast.containerAriaLabel')}
            toastOptions={{classNames: toastClassNames}}
        />
    )
}
